import { render, staticRenderFns } from "./sentenceM3.vue?vue&type=template&id=2b0d1206&scoped=true&"
import script from "./sentenceM3.vue?vue&type=script&lang=js&"
export * from "./sentenceM3.vue?vue&type=script&lang=js&"
import style0 from "./sentenceM3.vue?vue&type=style&index=0&id=2b0d1206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0d1206",
  null
  
)

export default component.exports